module.exports = __webpack_public_path__ + "img/our-story.8829bce4.png";